import React from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {Helmet} from 'react-helmet-async';
import StickyMobileBannerAdSlot from 'app/components/ads/StickyMobileBannerAdSlot';
import AllTransfers from 'app/components/district/transfers/AllTransfers';
import {ErrorHandler} from 'app/components/error/ErrorHandler';
import {useRestoreData} from 'app/hooks/dataHooks';
import DistrictTransfersResponse from 'app/models/district/transfers/DistrictTransfersResponse';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DistrictTransfersPage = ({name}) => {
  const {restoredData} = useRestoreData('DistrictTransfersPage');
  const initialState = restoredData ? new DistrictTransfersResponse(restoredData) : undefined;

  const title = 'Wechselbörse: Alle Transfers in';
  const meta = [
    {
      name: 'description',
      content: `${name} Wechselbörse: Alle Transfers - Aktuelle Transfermeldungen und Trainerwechsel über einen Neuzugang oder Abgang in den Teams des Fußballkreises ${name} in der Übersicht.`,
    },
    {
      name: 'robots',
      content: 'index, follow',
    },
  ];

  return (
    <>
      <ContentAdDesktop bgColor='none' top='7.125rem'>
        <Helmet title={title} meta={meta} />
        <ErrorHandler subroute={false}>
          <Wrapper>
            <AllTransfers initialState={initialState} hideSeoLinks={true} />
          </Wrapper>
        </ErrorHandler>
      </ContentAdDesktop>
      <StickyMobileBannerAdSlot />
    </>
  );
};

export default DistrictTransfersPage;
